/**
 * author: Ananthapadmanabhan V K
 */
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../constants/api";
//  import { notify } from "react-notify-toast";
export const baseURL = BASE_URL;

const incepForExcelAxios = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/octet-stream",
  },
  responseType: "blob"
});

const requestHandler = (request) => {
  return request;
};

const responseHandler = (response) => {
  return response;
};

const errorHandler = (error) => {
  if (error?.response?.status === 401) {
    //Logout on token invalid
    localStorage.clear();
    window.location.href = "/login";
  } else if (error?.response?.status === 400) {
    toast.error(error?.response?.data?.message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else if (error?.response?.status === 403) {
    toast.error("Not Authorized", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else if (error?.response?.status >= 500) {
    toast.error("Server error - Please retry after some time", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
  return Promise.reject(error);
};

incepForExcelAxios.interceptors.request.use(
  function (config) {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["Authorization"] = "Bearer " + accessToken;
    }
    return requestHandler(config);
  },
  function (error) {
    return Promise.reject(error);
  }
);

incepForExcelAxios.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

export default incepForExcelAxios;
